// Discuss (spec walkthrough 6): the Mono discussion a company's page starts
// — titled "<SYMBOL> — own?", its first post ending with a link back.
import { companyPath } from "./format";

export function discussionTitle(symbol) {
  return `${symbol} — own?`;
}

/** The opening post the dialog starts from (the person can change it). */
export function openingPost({ symbol, name }) {
  const who = name ? `${symbol} (${name})` : symbol;
  return (
    `Should we own ${who}? Make the case for and against here — the verdict ` +
    "itself is set on the company's page."
  );
}

/** The company page's full address. */
export function companyUrl(symbol, origin) {
  return `${origin}${companyPath(symbol)}`;
}

/** The post as sent: the person's text, then the link back. */
export function discussionBody({ symbol, text, origin }) {
  return `${text.trim()}\n\nCompany page: ${companyUrl(symbol, origin)}`;
}
